
import { EditorState, Modifier, ContentBlock, convertFromRaw, genKey } from 'draft-js';
import { html2content } from 'lib/convert';
import { filterEmptyBlocks } from 'lib/helpers';

const defaultOptions = {
	parseOptions: {},
};

/**
 * @return {DraftEditorPlugin}
 */
export function createPasteHtmlPlugin(options = defaultOptions) {
	options = { ...defaultOptions, ...options };

	/**
	 * @param {DraftEditorStore} store
	 * @param {string} html
	 */
	const handleHtmlInput = (store, html) => {
		const editorState = store.getEditorState();
		const currentContent = editorState.getCurrentContent();
		const selection = editorState.getSelection();
		if (store.getEditorEnviorment() !== 'root') {
			return 'not-handled';
		}

		// 代码块不粘贴 HTML 内容
		const selectedBlockStart = currentContent.getBlockForKey(selection.getStartKey());
		const selectedBlockEnd = currentContent.getBlockForKey(selection.getEndKey());
		if (selectedBlockStart === selectedBlockEnd && selectedBlockStart.getType() === 'code-block') {
			return 'not-handled';
		}

		const pastedContent = filterEmptyBlocks(html2content(html, options.parseOptions));
		let fragment = pastedContent.getBlockMap();

		if (fragment.size === 1) {
			fragment = fragment.merge({
				[genKey()]: convertFromRaw({
					blocks: [{ type: 'unstyled', text: '' }],
					entityMap: {}
				}).getFirstBlock()
			});
		}

		const newContent = Modifier.replaceWithFragment(currentContent, selection, fragment);
		return (
			store.setEditorState(
				EditorState.push(editorState, newContent, 'insert-fragment')
			),
			'handled'
		);
	};

	return {
		handlePastedHtml(store, html) {
			return handleHtmlInput(store, html);
		},
		handleFiles(store, selection, files) {
			const htmlFile = files.find(x => (x instanceof File && /\.html?$/i.test(x.name)));
			if (htmlFile && typeof FileReader === 'function') {
				try {
					const reader = new FileReader();
					reader.onload = () => {
						if (reader.readyState === reader.DONE) {
							handleHtmlInput(store, reader.result);
						}
					}
					reader.readAsText(htmlFile, 'utf8');
					return 'handled';
				}
				catch (err) {
					console.warn('html read error', err);
					return 'not-handled';
				}
			}
			return 'not-handled';
		}
	}
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/pasteHtmlPlugin/createPasteHtmlPlugin.js